import Overlay from '@components/overlay/overlay';
import { useClickOutside } from '@hooks/use-click-outside';
import cn from 'classnames';
import React, { useRef } from 'react';

import styles from './cart-sidebar.module.scss';

export interface CartSidebarProps {
  readonly open: boolean;
  toggleOpen(isOpen?: boolean): void;
}

const CartSidebar: React.FC<React.PropsWithChildren<CartSidebarProps>> = ({
  children,
  open,
  toggleOpen,
}) => {
  const panelRef = useRef<HTMLElement>(null);

  useClickOutside(
    panelRef,
    (e) => {
      if (open) {
        e.stopPropagation();
        toggleOpen(false);
      }
    },
    { capture: true },
  );

  return (
    <>
      {open ? <Overlay overlayKey="cart-sidebar"></Overlay> : null}
      <aside
        ref={panelRef}
        className={cn(styles.container, {
          [styles.isOpen]: open,
        })}
      >
        {children}
      </aside>
    </>
  );
};

export default CartSidebar;
